module.exports = __webpack_public_path__ + "img/icon-linkedin.7dac7ce0.svg";